import { Textarea } from '@/components/react/ui/textarea';
import { useFieldContext } from '@/components/react/form/hooks/form';
import { AnimatedPlaceholder } from '@/components/react/form/elements/AnimatedPlaceholder';

export const TextArea = ({ label }: { label: string }) => {
  const { name, state, handleChange } = useFieldContext<string>();

  return (
    <div className="relative">
      <Textarea
        className="border-brand-medium-gray text-brand-purple-black placeholder:text-brand-medium-gray peer focus-visible:border-brand-purple-bright focus-visible:ring-brand-focus flex field-sizing-content min-h-16 w-full rounded-sm border bg-transparent px-4 py-2.5 text-base text-base/[1.5] font-medium transition-[color,box-shadow] outline-none placeholder:h-0 placeholder:text-[0px] focus-visible:ring-2 disabled:cursor-not-allowed disabled:opacity-50"
        onChange={(e) => handleChange(e.target.value)}
        placeholder={label}
        value={state.value}
        id={name}
      />

      <AnimatedPlaceholder
        placeholder={label}
        requiredField={false}
        variant="textArea"
      />
    </div>
  );
};
